import { render, staticRenderFns } from "./MangeSidebar.vue?vue&type=template&id=f42c32c0&scoped=true"
import script from "./MangeSidebar.vue?vue&type=script&lang=js"
export * from "./MangeSidebar.vue?vue&type=script&lang=js"
import style0 from "./MangeSidebar.vue?vue&type=style&index=0&id=f42c32c0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f42c32c0",
  null
  
)

export default component.exports